var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 82,
    viewBox: "0 0 89 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3751 7.11399L62.3748 7.11379C55.9596 2.94933 48.535 0.75 40.9038 0.75C18.9569 0.75 1.104 18.8103 1.104 41.0003C1.104 63.1903 18.9569 81.25 40.9038 81.25C62.8508 81.25 80.703 63.1903 80.703 41.0003C80.703 39.6762 80.6414 38.3666 80.5188 37.0749L80.5188 37.0746C80.3616 35.4407 78.9291 34.2472 77.302 34.3986L77.3008 34.3987C75.6799 34.5576 74.4968 36.0126 74.6529 37.6492C74.7562 38.7502 74.8099 39.8696 74.8099 41.0003C74.8099 59.912 59.5956 75.2954 40.9038 75.2954C22.2114 75.2954 6.99713 59.912 6.99713 41.0003C6.99713 22.088 22.2114 6.70456 40.9038 6.70456C47.4026 6.70456 53.7261 8.57752 59.1866 12.1261L59.1868 12.1262C60.5593 13.0168 62.3796 12.6142 63.2619 11.2291L63.2621 11.2288C64.141 9.84457 63.7418 8.00401 62.3751 7.11399ZM77.3252 34.6476C78.8137 34.5091 80.1258 35.6004 80.27 37.0985L74.9018 37.6259C74.7583 36.1237 75.8439 34.7927 77.3252 34.6476Z",
    fill: "#1377D4",
    stroke: "#1377D4",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4009 43.1501L31.3045 28.8932C30.1533 27.7288 28.2858 27.7288 27.1346 28.8932C25.9849 30.0559 25.985 31.9398 27.1345 33.1032L27.1346 33.1033L43.3134 49.4664C43.3135 49.4665 43.3136 49.4665 43.3136 49.4666C43.8872 50.0503 44.6428 50.3408 45.397 50.3408C46.1519 50.3408 46.9063 50.0502 47.4833 49.4709L47.4839 49.4703L87.0337 9.46993C88.1834 8.30718 88.1834 6.42324 87.0337 5.2605C85.8825 4.09616 84.015 4.09624 82.8632 5.26045L82.8631 5.2605L45.4009 43.1501Z",
    fill: "#1377D4",
    stroke: "#1377D4",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.9f3f957405b2a8603a260c9618fce6be.svg";
export { ForwardRef as ReactComponent };